import {
  complementaryConfigurationColumnHTML,
  virtualConfigurationColumnHTML,
  complementaryColumnHTML,
  virtualColumnHTML,
} from '@/components/Layout/Columns/columnInfo';
import { mapGetters } from 'vuex';

export default {
  name: "LayoutImportMixin",

  methods: {
    isCommonColumn(column) {
      return column.columnType === 'DEFAULT'
        && column.complementaryLayout === false;
    },

    isComplementaryColumn(column) {
      return column.columnType === 'DEFAULT'
        && column.complementaryLayout === true;
    },

    isVirtualColumn(column) {
      return column.columnType === 'VIRTUAL';
    },

    sortColumns(columns) {
      columns.sort((a, b) => (a.order > b.order ? 1 : -1));

      const columnsOrdened = [];

      columns.forEach((column, index) => {
        const elementId =
        column && column.id && column.id.toString().includes('new_column')
            ? `new_column_${index + 1}`
            : column.id;

        columnsOrdened.push({
          ...column,
          id: elementId,
          order: index + 1,
        });
      });

      return columnsOrdened;
    },

    setColumnIcon(column) {
      if (this.isComplementaryColumn(column)) return 'far fa-copyright';

      if (this.isVirtualColumn(column)) return 'fas fa-bolt';
    },

    setColumnInfo(column) {
      if (this.isComplementaryColumn(column))
        return complementaryConfigurationColumnHTML;

      if (this.isVirtualColumn(column))
        return virtualConfigurationColumnHTML;

      return false;
    },

    setTransformationColumnInfo(column) {
      if (this.isComplementaryColumn(column))
        return complementaryColumnHTML;

      if (this.isVirtualColumn(column))
        return virtualColumnHTML;

      return false;
    },
  },

  computed: {
    ...mapGetters({
      layoutColumnsStore: 'layout-import/layoutColumns',
    }),

    inLayoutImportRoute() {
      return this.$route.name === 'LayoutImports';
    },

    inLayoutImportRoutesFlow() {
      const layoutImportRoutes = [
        "LayoutImportColumnEditConfigs",
        "LayoutImportColumnConfigs",
      ];

      return layoutImportRoutes.includes(this.$route.name);
    },

    hasOnlyCommonColumns() {
      return this.layoutColumnsStore.every(
        (column) => this.isCommonColumn(column));
    },

    hasComplementaryColumns() {
      return this.layoutColumnsStore.some(
        (column) => this.isComplementaryColumn(column));
    },

    hasVirtualColumns() {
      return this.layoutColumnsStore.some(
        (column) => this.isVirtualColumn(column));
    },
  },
};
